import { lazyWithPreload } from 'react-lazy-with-preload';

const PostCommunicationListPage = lazyWithPreload(() => import('./pages/progress-line-post-list/Page'));

const Routes = [
    {
        path: 'progress-line-communication',
        element: <PostCommunicationListPage />,
    },
];

export default Routes;
